/**
 * Optional haptic cues for the breathing session.
 * Capability-checked (navigator.vibrate) and setting-gated; every cue is a
 * short, gentle pulse. All cues are no-ops when disabled or unsupported.
 */

export function isVibrationSupported(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function'
}

export type HapticCues = {
  cueIn: () => void
  cueHold: () => void
  cueOut: () => void
  cueDone: () => void
}

function vibrate(pattern: number | number[]): void {
  if (!isVibrationSupported()) return
  try {
    navigator.vibrate(pattern)
  } catch {
    // Vibration is best-effort; never break the session over it.
  }
}

const NOOP_CUES: HapticCues = {
  cueIn: () => undefined,
  cueHold: () => undefined,
  cueOut: () => undefined,
  cueDone: () => undefined,
}

export function createHapticCues(enabled: boolean): HapticCues {
  if (!enabled || !isVibrationSupported()) return NOOP_CUES
  return {
    cueIn: () => vibrate(15),
    cueHold: () => vibrate(10),
    cueOut: () => vibrate([10, 40, 10]),
    cueDone: () => vibrate([20, 60, 20, 60, 20]),
  }
}
